import { all } from 'redux-saga/effects'
import {
  watchGetFieldOfWork,
  watchGetEinvoiceOperatorsSaga,
  watchLoadProfileSaga,
  watchUpdateProfileSaga
} from './companyProfile.saga'
import {
  watchGetEntrepreneursSaga,
  watchAddLightEntrepreneursSaga,
  watchRemoveLightEntrepreneursSaga,
  watchSetFavouriteEntrepreneursSaga
  // watchPreviewContractSaga,
  // watchSignAndSendContractSaga,
} from './lightEntrepreneurs.saga'
import { watchSendRegisterInfoSaga } from './register.saga'
import {
  watchLoginSaga,
  watchLogoutSaga,
  watchGetLangFromSiteSaga
} from './login.saga'
import { watchChangeLanguageSaga } from '../lang.saga'
import { watchResetPasswordSaga } from './resetPassword.saga'
//company details
import {
  watchCompanyDetailsSearch,
  watchLoadSelectedCompanySaga
} from '../companyDetails.saga'
import {
  watchGetAssignmentsSaga,
  watchAddNewAssignmentSaga,
  watchEditAssignmentSaga,
  watchCancelEditAssignmentSaga,
  watchDeleteAssignmentSaga,
  watchCopyAssignmentSaga,
  watchSaveAssignmentAsDraftSaga,
  watchGetAreaOfWorkSaga,
  watchGetEmployerContractListSaga,
  watchPinAssignmentSaga
} from './assignments.saga'
import { watchUpdatePasswordSaga } from './password.saga'
import {
  watchGetApplicantDetailsSaga,
  watchUpdateViewedApplicationSaga,
  watchUpdateReviewedApplicationDetailsSaga,
  watchGetTotalApplicationsSaga,
  watchRejectApplicationSaga,
  watchEditAssignmentAppSaga,
  watchPreviewAssignmentSaga,
  watchSignSendContractSaga,
  watchUpdateApplicationStatusSaga,
  watchGetOfferedFromLightEntreSaga,
  watchPinApplicationSaga
} from './../employer/applications.saga'
import {
  watchGetWorkshiftsSaga,
  watchGetBillableHoursSaga,
  watchAddWorkShiftsSaga,
  watchGetWorkshiftByIdSaga,
  watchConfirmBillableHourSaga,
  watchRemoveWorkshiftSaga,
  watchUpdateWorkshiftSaga,
  watchGetSignedLESaga,
  watchPinWorkshiftSaga
} from './workshifts.saga'
import { watchCountryListSaga } from '../customer.saga'

// Single entry point to start all sagas at once
export default function* rootSaga() {
  try {
    yield all([
      watchSendRegisterInfoSaga(),
      watchLoginSaga(),
      watchLogoutSaga(),
      watchGetLangFromSiteSaga(),
      watchChangeLanguageSaga(),
      watchResetPasswordSaga(),
      watchCompanyDetailsSearch(),
      watchLoadSelectedCompanySaga(),
      watchGetFieldOfWork(),
      watchGetEinvoiceOperatorsSaga(),
      watchGetEntrepreneursSaga(),
      watchLoadProfileSaga(),
      watchUpdateProfileSaga(),
      watchUpdatePasswordSaga(),
      watchAddLightEntrepreneursSaga(),
      watchRemoveLightEntrepreneursSaga(),
      watchSetFavouriteEntrepreneursSaga(),
      // watchPreviewContractSaga(),
      watchGetAssignmentsSaga(),
      watchAddNewAssignmentSaga(),
      watchEditAssignmentSaga(),
      watchCancelEditAssignmentSaga(),
      watchDeleteAssignmentSaga(),
      watchCopyAssignmentSaga(),
      watchSaveAssignmentAsDraftSaga(),
      // watchSignAndSendContractSaga(),
      watchGetApplicantDetailsSaga(),
      watchUpdateViewedApplicationSaga(),
      watchUpdateReviewedApplicationDetailsSaga(),
      watchGetTotalApplicationsSaga(),
      watchRejectApplicationSaga(),
      watchEditAssignmentAppSaga(),
      watchPreviewAssignmentSaga(),
      watchSignSendContractSaga(),
      watchGetWorkshiftsSaga(),
      watchGetBillableHoursSaga(),
      watchAddWorkShiftsSaga(),
      watchGetWorkshiftByIdSaga(),
      watchConfirmBillableHourSaga(),
      watchRemoveWorkshiftSaga(),
      watchUpdateWorkshiftSaga(),
      watchGetSignedLESaga(),
      watchUpdateApplicationStatusSaga(),
      watchGetAreaOfWorkSaga(),
      watchGetOfferedFromLightEntreSaga(),
      watchGetEmployerContractListSaga(),
      watchPinApplicationSaga(),
      watchPinWorkshiftSaga(),
      watchPinAssignmentSaga(),
      watchCountryListSaga()
    ])
  } catch (e) {
    console.error('Error in `rootSaga`: ', e)
  }
}
